import React from 'react'
import PropTypes from 'prop-types'

export function BadgeReviewImage(props) {
  return (
    <div>
      <img
        id="target"
        src={props.imageLoaded ? props.image : ''}
        alt={
          props.imageName ? props.imageName : props.imageType + ' Badge Image'
        }
        style={{ maxHeight: 100, maxWidth: 100 }}
      />
    </div>
  )
}

BadgeReviewImage.propTypes = {
  imageLoaded: PropTypes.bool,
  image: PropTypes.string,
  imageName: PropTypes.string,
  imageType: PropTypes.string,
}
